export default __webpack_public_path__ + "static/media/NoProductSelected.dbbfbaa1.svg";